import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { MenuInfo } from '@/types/menu'
import router from '@/router'
import { getSchoolMenuList } from '@/api/menu'

export const useMenuStore = defineStore('menu', () => {
  // 菜单数据缓存
  const menuList = ref<MenuInfo[]>([])
  const schoolMenuList = ref<MenuInfo[]>([])
  // 设置菜单数据
  const setMenuList = (menus: MenuInfo[]) => {
    menuList.value = menus
  }

  // 获取菜单数据
  const getMenuList = () => {
    return menuList.value
  }
  
  // 获取当前学校菜单列表
  const fetchSchoolMenuList = async () => {
    try {
      const res = await getSchoolMenuList()
      schoolMenuList.value = res
       return res

      throw new Error(res.message || '获取菜单列表失败')
    } catch (error) {
      console.error('获取学校菜单列表失败:', error)
      return []
    }
  }

  // 清空菜单数据
  const clearMenuList = () => {
    menuList.value = []
    // 清除动态添加的路由
    router.getRoutes().forEach(route => {
      if (route.name && route.name !== 'login') {
        router.removeRoute(route.name)
      }
    })
  }

  return {
    menuList,
    schoolMenuList,
    setMenuList,
    getMenuList,
    fetchSchoolMenuList,
    clearMenuList
  }
}) 